import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux"
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import CandidateTab from "../components/CandidateTab";
import FeatherIcon from "feather-icons-react";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import "../assets/css/education-digilocker.css";
import UploadIconBlue from "../assets/img/upload-icon-blue.svg";
import { saveEducation } from './educationActions';



const EducationDigilocker =(props)=>{

  const {education, handleSubmitForPreview} = props
  const dispatch = useDispatch();
  const handleDownload = (url) =>{
    const aElement = document.createElement("a");
    aElement.setAttribute("download", "download");
    // const href = URL.createObjectURL(obj);
    aElement.href = url;
    aElement.setAttribute("target", "_blank");
    aElement.click();
    console.log(url)
  }

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

const handleSubmit = () =>{
  
  const recordData = JSON.parse(localStorage.getItem('recordData'));
  recordData.isDigilocker_completed = 1;
  dispatch(saveEducation(recordData));
}

function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
}

  const digiLockerData = JSON.parse(localStorage.getItem('digilocker_data'));
  console.log(digiLockerData)
  useEffect(() => {
    
  }, [digiLockerData]);
    return (
        <>
        <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
             <div className="col bg-gray p-3 digilocker">
              <div className="col-md-10">
            <div className="p-3">
            <h5 class="fnt-16 fnt-smi-bld">Uploaded documents via Digilocker</h5>
            <div class="table-responsive mt-4 upload-doc-digi">
              <table class="table">
                <tr style={{backgroundColor:"#F2F5F7", fontWeight:"600"}}>
                  <td>University/Board</td>
                  <td>Document Type </td>
                  {/* <td>Roll Number</td>
                  <td>Year of Passing </td> */}
                  {/* <td>Document Type</td> */}
                  <td>Actions</td>
                </tr>
                {digiLockerData?.data?.map((item)=>{
                  return(<tr>
                    <td>{item.org_name}</td>
                    <td>{item.doc_name}</td>
                    {/* <td>{item.doc_type}</td> */}
                    
                    <td> 
                        {isValidUrl(item.s3_file_url)?<FeatherIcon icon="download" class="ml-4" onClick={(e) => {
                        e?.preventDefault();
                        handleDownload(item.s3_file_url)
                      }}/>: <span style={{color:'red'}}>Not Available</span>}
                      
                    
                   
                    </td>
                  </tr>)
                })}
                {digiLockerData?.data?.length==0 && <tr><td>No Data Found.</td></tr>}
              </table>
            </div>
            {/* <h5 class="fnt-16 fnt-smi-bld">Not Available on Digilocker</h5> */}
            {/* <div class="table-responsive mt-4 upload-doc-digi">
              <table class="table">
                <tr style={{backgroundColor:"#F2F5F7", fontWeight:"600"}}>
                  <td>Qualification </td>
                  <td>University/Board</td>
                  <td>Roll Number</td>
                  <td>Year of Passing </td>
                  <td>Document Type</td>
                  <td>Actions</td>
                </tr>
                <tr>
                  <td>Senior Sec (12th)</td>
                  <td>CBSE</td>
                  <td>109856781</td>
                  <td>2010</td>
                  <td style={{color:'red'}}>Not Available*</td>
                  <td> 
                  </td>
                </tr>
                <tr>
                  <td>Senior Sec (12th)</td>
                  <td>CBSE</td>
                  <td>109856781</td>
                  <td>2010</td>
                  <td style={{color:'red'}}>Not Available*</td>
                  <td> 
                  </td>
                </tr>
              </table>
            </div> */}
            
            {/* <h5 class="fnt-16 fnt-smi-bld ml-2"> Upload  Required Documents</h5>
            <div class="digi-doc">
            <div className="d-flex justify-content-between align-item-end p-3">
            <h5 class="fnt-16 fnt-smi-bld">Education 3:</h5>
            <div class="d-flex ">
              <input type="checkbox"  /> 
              <label class="fnt-16 fnt-smi-bld ml-4">I will submit documents later</label>
            </div>
            </div>
            <div class="table-responsive  upload-doc-digi">
              <table class="table">
                <tr style={{backgroundColor:"#F2F5F7", fontWeight:"600"}}>
                  <td>Qualification </td>
                  <td>University/Board</td>
                  <td>Collage/School</td>
                  <td>Year of Passing </td>
                  <td>Location</td>
                  <td>Actions</td>
                </tr>
                <tr>
                  <td>B.com</td>
                  <td>Delhi University</td>
                  <td>Collage of Applied Arts</td>
                  <td>2010</td>
                  <td>New Delhi</td>
                  <td> <FeatherIcon icon="edit" /> <span class="ml-2">Edit</span> </td>
                </tr>
               
              </table>
            </div>

            <div className="row d-flex justify-content-between align-item-end  mt-4">
              <div className="col-md-6">
              <h6 class="fnt-14 fnt-smi-bld ml-2"> Upload Marksheets ( All semester)</h6>
              <div class="upload-doc text-center p-3  mt-3">
                <input type="file" />
                <ul class="list-style-none mt-2 p-0">
                  <li><img src={UploadIconBlue} /></li>
                  <li class="fnt-14 text-primary mt-4"><span class="fnt-smi-bld"> Click to upload </span> (Only  JPG, PNG & PDF)</li>
                </ul>
              </div>
              <div class="table-responsive">
              <table class="table mt-3 document">
                <tr>
                  <td width="5px"><FeatherIcon icon="edit" /></td>
                  <td class="fnt-12">Marksheet-1_2000.jpg</td>
                  <td><FeatherIcon icon="eye" /></td>
                  <td><FeatherIcon icon="download" /></td>
                  <td><FeatherIcon icon="trash" /></td>
                </tr>
                <tr>
                  <td width="5px"><FeatherIcon icon="edit" /></td>
                  <td class="fnt-12">Marksheet-1_2000.jpg</td>
                  <td><FeatherIcon icon="eye" /></td>
                  <td><FeatherIcon icon="download" /></td>
                  <td><FeatherIcon icon="trash" /></td>
                </tr>
              </table>
              </div>
              </div>
              <div className="col-md-6">
              <h6 class="fnt-14 fnt-smi-bld ml-2"> Upload Degree/certificate</h6>
              <div class="upload-doc text-center p-3 mt-3">
                <input type="file" />
                <ul class="list-style-none mt-2 p-0">
                  <li><img src={UploadIconBlue} /></li>
                  <li class="fnt-14 text-primary mt-4"><span class="fnt-smi-bld"> Click to upload </span> (Only  JPG, PNG & PDF)</li>
                </ul>
              </div>
              <div class="table-responsive">
              <table class="table mt-3 document">
                <tr>
                  <td width="5px"><FeatherIcon icon="edit" /></td>
                  <td class="fnt-12">Marksheet-1_2000.jpg</td>
                  <td><FeatherIcon icon="eye" /></td>
                  <td><FeatherIcon icon="download" /></td>
                  <td><FeatherIcon icon="trash" /></td>
                </tr>
                <tr>
                  <td width="5px"><FeatherIcon icon="edit" /></td>
                  <td class="fnt-12">Marksheet-1_2000.jpg</td>
                  <td><FeatherIcon icon="eye" /></td>
                  <td><FeatherIcon icon="download" /></td>
                  <td><FeatherIcon icon="trash" /></td>
                </tr>
              </table>
              </div>
                </div>

            </div>

            
            </div> */}

            <div class="d-flex mt-5 mb-5">
            <button class="btn btn-primary ml-4" onClick={handleSubmit}>Continue</button>
            </div>
            {education.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
            </div>
             </div>
            </div>

          </div>
        </div>
      </section>
        </>
    )
}

export default EducationDigilocker;